import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserService } from '../services/userService';

const INACTIVITY_LIMIT = 30 * 60 * 1000; // 30 minutos

export const SessionTimeout = () => {
    const navigate = useNavigate();

    useEffect(() => {
        const checkInactivity = () => {
            const lastActivity = localStorage.getItem('lastActivity');
            if (lastActivity && Date.now() - parseInt(lastActivity) > INACTIVITY_LIMIT) {
                UserService.logout();
            }
        };

        const updateActivity = () => {
            localStorage.setItem('lastActivity', Date.now().toString());
        };

        // Eventos de interação
        const events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart'];

        events.forEach(event => window.addEventListener(event, updateActivity));
        const interval = setInterval(checkInactivity, 60000); // Verifica a cada minuto

        return () => {
            events.forEach(event => window.removeEventListener(event, updateActivity));
            clearInterval(interval);
        };
    }, [navigate]);

    return null;
};
